export default __webpack_public_path__ + "static/media/Table Tracking.95421997.png";